import React from "react";
import Loader from "../components/Loader";

import Post from "../components/Post";

const PostList = ({
  loading,
  postList,
  likePostHandler,
  // isEdit,
  expertiesKey,
  deleteHandler = null,
  editHandler = null,
  reportPostHandler = null,
  bookHandler = null,
  retweetHandler = null,
}) => {
  const youtubeRegex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=|shorts\/)|youtu\.be\/)([\w\-]+)/;
  const facebookVideoRegex =
    /(?:https?:\/\/)?(?:www.|web.|m.)?(facebook|fb).(com|watch)\/(?:video.php\?v=\d+|(\S+)|photo.php\?v=\d+|\?v=\d+)|\S+\/videos\/((\S+)\/(\d+)|(\d+))\/?/;
  const facebookReelRegex =
    /(?:https?:\/\/)?(?:www\.)?facebook\.com\/(?:watch\/)?(?:\?v=)?(\d+)/;

  const isValidUrl = (videoLink) => {
    if (
      videoLink?.includes("https://fb") ||
      videoLink?.includes("facebook.com")
    ) {
      if (facebookReelRegex.test(videoLink)) {
        return true;
      } else if (facebookVideoRegex.test(videoLink)) {
        return true;
      } else {
        return false;
      }
    } else if (videoLink.includes("instagram.com")) {
      return true;
    } else if (youtubeRegex.test(videoLink)) {
      return true;
    } else if (videoLink.includes("linkedin.com")) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      {loading && <Loader />}
      {!loading && postList.length === 0 && (
        <p className="mt-4">
          <strong>There are no posts available</strong>
        </p>
      )}
      {!loading &&
        postList.length > 0 &&
        postList.map((post) => {
          if (post.type === "reels" && post?.url && isValidUrl(post?.url)) {
            return (
              <Post
                key={post.id} // Make sure to add a unique key prop
                post={post}
                deleteHandler={deleteHandler}
                editHandler={editHandler}
                likePostHandler={likePostHandler}
                expertiesKey={expertiesKey}
                reportPostHandler={reportPostHandler}
                bookHandler={bookHandler}
                retweetHandler={retweetHandler}
              />
            );
          } else if (post.type !== "reels") {
            // If type is not 'reels' or if URL is invalid, directly return the component
            return (
              <Post
                key={post.id} // Make sure to add a unique key prop
                post={post}
                deleteHandler={deleteHandler}
                editHandler={editHandler}
                likePostHandler={likePostHandler}
                expertiesKey={expertiesKey}
                reportPostHandler={reportPostHandler}
                bookHandler={bookHandler}
                retweetHandler={retweetHandler}
              />
            );
          }
        })}
    </>
  );
};

export default PostList;
